import { render, staticRenderFns } from "./VestingBulkUpload.vue?vue&type=template&id=3a0d0d08"
import script from "./VestingBulkUpload.vue?vue&type=script&lang=js"
export * from "./VestingBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./VestingBulkUpload.vue?vue&type=style&index=0&id=3a0d0d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports